__turbopack_context__.v({
  "badge": "badge-module-scss-module__-uYMeW__badge",
});
